<template>
  <footer>
    <div class="foot-nav-container pc_padding">
      <div class="footer-about">
        <div class="footer-item-title">
          About us
        </div>
        <div class="footer-item-content">
          {{ domainConfig['ABOUTUS'] }}
        </div>
      </div>
      <div class="footer-side-row">
        <div class="footer-side-resource">
          <div class="footer-item-title">
            Resources
          </div>
          <div class="footer-item-content resource">
            <div class="footer-item-content-item cursor" @click="goto('terms')">
              Terms of services
            </div>
            <div class="footer-item-content-item cursor" @click="goto('privacy')">
              Privacy policy
            </div>
            <div class="footer-item-content-item cursor" @click="goto('disclaimer')">
              Disclaimer
            </div>
          </div>
        </div>
        <div class="footer-side-contact">
          <div class="footer-item-title">
            Contact us
          </div>
          <div class="footer-item-content">
            <a class="footer-item-content-item"
              :href="`mailto:${domainConfig['IAMEMAIL']}`">{{ domainConfig['IAMEMAIL'] }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="corner-module pc_padding">
      Copyright © 2024 {{ domainConfig['title'] }}. All Rights Reserved.
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FootModule1',
  computed: {
    ...mapGetters(["domainConfig"]),
  },
  methods: {
    goto (where) {
      let path = '';
      switch (where) {
        case 'terms':
          path = '/terms-of-services';
          break;
        case 'privacy':
          path = '/privacy-policy';
          break;
        case 'disclaimer':
          path = '/disclaimer';
          break;
        default:
          path = '/';
      }
      this.navigateTo(path);
    },
    navigateTo (path) {
      const currentParams = this.$router.currentRoute.params;
      const currentQuery = this.$route.query;

      const channel = currentParams.channel ? `/${currentParams.channel}` : '';
      const queryString = new URLSearchParams(currentQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      const baseUrl = window.location.origin;
      window.location.href = `${baseUrl}${channel}${path}${fullQueryString}`;
    }
  },
};
</script>
